<template>
  <div id="page_insights_charity" class="column p-component-card">
    <div class="component_card_border_bottom">
      <h1 class="component_title_md fat main_blue_dk_fill tal_c">
        <p>{{$t("msg.charity")}}</p>
      </h1>
    </div>
    <div class>
      <div class="column tal_c">
        <p>{{$t("msg.charity_sub")}}</p>
      </div>
    </div>

    <div class="columns component_card_border_bottom">
      <div class="column">
        <a class="charity-image" href="https://www.bitgivefoundation.org/" target="_blank">
          <img :src="charity[0].image" class="charity-image" />
        </a>
      </div>
      <div class="column text-charity">
        <span class="tal_r_b val_m">{{charity[0].amout}} BTC</span>
      </div>
    </div>
    <div class="column">
      <div class="columns split_half_text">
        <div class="column">
          <a class="charity-image" href="https://www.b4h.world/" target="_blank">
            <img :src="charity[1].image" class="charity-image" />
          </a>
        </div>
        <div class="column text-charity">
          <span class="tal_r_b val_m">{{charity[0].amout}} BTC</span>
        </div>
      </div>
      <div>
        <p class="column p0 text_ssm">{{$t("msg.last_update")}} 01/04/2020</p>
      </div>
    </div>
  </div>
</template>
<script>
import img1 from "../../../assets/images/charity/bitgive.png";
import img2 from "../../../assets/images/charity/b4h.png";

export default {
  created() {},
  components: {
    img1
  },
  data: () => ({
    charity: [
      {
        name: "bitgive",
        amout: "0.0058",
        image: img1
      },
      {
        name: "b4h",
        amout: "0.0058",
        image: img2
      }
    ]
  })
};
</script>




// WEBPACK FOOTER //
// src/components/private/insights/InsightsCharity.vue